import React, { useEffect, useRef } from "react"

import { copyTextToClipboard } from "../../utils"

import "../../style/copy-box.module.css"

interface Props {
  value: string,
  copyCallback?: Function
  overrideClass?:string
}
/**
 * @warning: This component behaves unexpectedly when used inside of a absolute container's (ex: modals).
 * instead use <CopyBox2/>.
 */

const CopyBox = (props: Props) => {
  const copyBoxRef = useRef<HTMLDivElement>(null)
  const copyAlertRef = useRef<HTMLSpanElement>(null)

  const copyText = () => {
    copyTextToClipboard(props.value)
      .then(() => showAlert())
      .catch((err) => console.error(err))
    
    if (props.copyCallback) {
      props.copyCallback()
    }
  }

  const showAlert = () => {
    if (copyAlertRef.current != null) {
      setAlertPosition(copyBoxRef, copyAlertRef)
      copyAlertRef.current.classList.add("visible")
      setTimeout(hideAlert, 1000)
    }
  }
  
  const hideAlert = () => {
    if (copyAlertRef.current) {
      copyAlertRef.current.classList.remove("visible")
    }
  }
  
  /**
   * Put alert horizontally on the (right + 12px space) of CopyBox, and vertically centered to the CopyBox
   */
  const setAlertPosition = (copyBoxRef: React.RefObject<HTMLDivElement>, copyAlertRef: React.RefObject<HTMLSpanElement>) => {
    if (copyBoxRef.current != null && copyAlertRef.current != null) {
      const copyBoxRect = copyBoxRef.current.getBoundingClientRect()
      if (copyBoxRect !== undefined) {
        // top position also use the CSS `transform: translateY(-50%)`
        copyAlertRef.current.style.top = copyBoxRect.top + document.body.scrollTop + (copyBoxRect.height / 2) + 'px';
        copyAlertRef.current.style.left = copyBoxRect.left + document.body.scrollLeft + copyBoxRect.width + 12 + 'px';
      }
    }
  }

  useEffect(() => {
    // hide alert on scroll, otherwise the alert will look not aligned with the CopyBox
    const onScroll = () => hideAlert();
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return <>
    <div className={"copy-box " + props.overrideClass} ref={copyBoxRef}>
      <p>{props.value}</p>
      <span
        className="copy-box__copy"
        onClick={copyText}
      >
        <img src="static/assets/dashboard/copy-clipboard.png" alt="Click to copy" />
      </span>
    </div>
    <span
      ref={copyAlertRef}
      className="copy-box__alert"
    >
      Copied!
    </span>
  </>
}

export const CopyBox2 = (props: Props) => {
  const copyAlertRef = useRef<HTMLSpanElement>(null)

  const copyText = () => {
    copyTextToClipboard(props.value)
      .then(() => showAlert())
      .catch((err) => console.error(err))
    
    if (props.copyCallback) {
      props.copyCallback()
    }
  }

  const showAlert = () => {
    if (copyAlertRef.current != null) {
      copyAlertRef.current.classList.add("visible")
      setTimeout(hideAlert, 1000)
    }
  }
  
  const hideAlert = () => {
    if (copyAlertRef.current) {
      copyAlertRef.current.classList.remove("visible")
    }
  }
  

  return <>
    <div className={"copy-box " + props.overrideClass}>
      <p>{props.value}</p>
      <span
        className="copy-box__copy relative"
        onClick={copyText}
      >
        <img src="static/assets/dashboard/copy-clipboard.png" alt="Click to copy" />
        <span
          ref={copyAlertRef}
          className="absolute copy-box__alert"
        >
          Copied!
        </span>
      </span>
    </div>
    
  </>
}

export default CopyBox
